<template>
    <div class="discount-code form__group" :class="{ 'form__group--error' : form.errors.has('coupon') }">
        <label for="coupon" class="form__label">Coupon <span class="highlight">(optional)</span></label>
        <div>
            <input id="coupon" type="text" class="discount-code__input form__input" :disabled="hasCoupon" v-model="form.coupon">

            <button v-if="hasCoupon" @click.prevent="remove" class="discount-code__button button button--outline">Remove</button>
            <button v-else @click.prevent="apply" class="discount-code__button button button--outline">Apply</button>
        </div>
        <div v-if="coupon" v-html="discountedText" class="discount-code__applied"></div>

        <p v-if="form.errors.has('coupon')" class="form__help form__help--error">{{ form.errors.get('coupon') }}</p>
    </div>
</template>
<script>
import Form from '../../../helpers/Form'
import currentTenantAware from '../../../mixins/currentTenantAware'

export default {
    mixins: [currentTenantAware],

    props: {
        value: {
            type: String
        }
    },

    data () {
        return {
            coupon: null,
            form: new Form({
                coupon: ''
            })
        }
    },

    mounted () {
        if (this.value) {
            this.form.coupon = this.value
            this.apply()
        }
    },

    methods: {
        apply () {
            this.$store.dispatch('tenant/applyCoupon', this.form).then((response) => {
                this.coupon = response.coupon
                this.$store.commit('tenant/setPrices', response)
                this.$emit('input', this.coupon.id)
            }).catch(() => {
                this.reset()
            })
        },

        remove () {
            this.form.coupon = ''
            this.reset()
            this.$emit('input', '')
        },

        reset () {
            this.coupon = null
            this.resetPrices()
        }
    },

    computed: {
        hasCoupon () {
            return this.coupon !== null
        },

        discounted () {
            return this.coupon.amount_off ? `&dollar;${this.coupon.amount_off}` : `%${this.coupon.percent_off}`
        },

        discountedText () {
            return `<strong>${this.discounted} off</strong> coupon applied 🎉`
        }
    }
}
</script>
